import { composeIO } from 'react-compose-io'
import { cadastrarNovoParceiroIO } from './CadastrarNovoParceiro.IO'
import { CadastrarNovoParceiroView } from './CadastrarNovoParceiro.View'

export const CadastrarNovoParceiro = composeIO(CadastrarNovoParceiroView, cadastrarNovoParceiroIO)
